module.exports = "\n  <router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /home/isai/funeraria/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main